module.exports = __webpack_public_path__ + "static/media/IconTemplates_-41.5143b7e2.svg";